var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGrass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 226"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 203",
    fill: "#6f9d20",
    d: "M0 0h252v226H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 334",
    d: "M27.003 132.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 335",
    d: "M9.003 172.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 336",
    d: "M225.003 64.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 337",
    d: "M205.003 30.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 338",
    d: "M222.003 172.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 339",
    d: "M186.003 192.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 340",
    d: "M11.003 99.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 341",
    d: "M43.003 56.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 342",
    d: "M9.003 30.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 343",
    d: "M65.003 30.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 344",
    d: "M53.003 190.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 345",
    d: "M234.003 8.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 346",
    d: "M43.003 9.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 347",
    d: "M102.003 8.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 348",
    d: "M171.003 8.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 349",
    d: "M216.003 214.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 350",
    d: "M18.003 214.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 352",
    d: "M82.003 215.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 353",
    d: "M69.003 94.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M177.003 90.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 354",
    d: "M96.003 57.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 355",
    d: "M162.003 57.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 356",
    d: "M134.003 30.967a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 357",
    d: "M144.003 215.467a1.317 1.317 0 01.932-.71 2.645 2.645 0 011.2.059c.694.171 1.347.476 2.033.676a3.289 3.289 0 002.1.03c.983-.385 1.672-1.489 2.728-1.522",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))));
}

export default __webpack_public_path__ + "349e12c57fdb55c24885c68014b45e0f.svg";
export { SvgIconGrass as ReactComponent };